<template>
    <div>
        <div class="alert alert-danger" v-if="syncError">
            {{syncErrorMessage}}
        </div>
        <div class="alert alert-warning">
            Enable and setup up the url's for each review site that you want to read reviews.
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-yelp': form.yelp}" @click="reviewSite('yelp')">
                    <i class="fab fa-yelp"></i> Yelp
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.yelp.com/biz/swell-reviews"
                    v-model="form.yelp_url"
                    :form="form"
                    field="yelp_url"
                    :readonly="!form.yelp"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.yelp">
                <a href="https://www.yelp.com/" data-toggle="tooltip" target="_blank"
                    title="Find your establishment">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressYelp"
                                @click="clearAndSyncReviews('Yelp')">
                    <i class="fas fa-sync" v-if="!syncInProgressYelp"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-google': form.google}"
                    @click="reviewSite('google')">
                    <i class="fab fa-google"></i> Google
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.google.com/maps/place/swell+reviews"
                    v-model="form.google_url"
                    :form="form"
                    field="google_url"
                    :readonly="!form.google"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.google">
                <a href="https://www.google.com/maps/" data-toggle="tooltip" target="_blank"
                    title="Find your region">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressGoogle"
                                @click="clearAndSyncReviews('Google')">
                    <i class="fas fa-sync" v-if="!syncInProgressGoogle"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-tripadvisor': form.trip_advisor}"
                        @click="reviewSite('trip_advisor')">
                    <i class="fab fa-tripadvisor"></i> Trip Advisor
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.tripadvisor.com/swell_reviews"
                    v-model="form.trip_advisor_url"
                    :form="form"
                    field="trip_advisor_url"
                    :readonly="!form.trip_advisor"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.trip_advisor">
                <a href="https://www.tripadvisor.com" data-toggle="tooltip" target="_blank"
                    title="Find your establishment">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressTripAdvisor"
                                @click="clearAndSyncReviews('TripAdvisor')">
                    <i class="fas fa-sync" v-if="!syncInProgressTripAdvisor"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-capterra': form.capterra}"
                        @click="reviewSite('capterra')">
                    Capterra
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.capterra.com/swell-reviews"
                    v-model="form.capterra_url"
                    :form="form"
                    field="capterra_url"
                    :readonly="!form.capterra"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.capterra">
                <a href="https://www.capterra.com" data-toggle="tooltip" target="_blank"
                    title="Find business software">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressCapterra"
                                @click="clearAndSyncReviews('Capterra')">
                    <i class="fas fa-sync" v-if="!syncInProgressCapterra"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-software-advice': form.software_advice}"
                        @click="reviewSite('software_advice')">
                    Software Advice
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.softwareadvice.com/swell-reviews"
                    v-model="form.software_advice_url"
                    :form="form"
                    field="software_advice_url"
                    :readonly="!form.software_advice"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.software_advice">
                <a href="https://www.softwareadvice.com" data-toggle="tooltip" target="_blank"
                    title="Find software applications">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressSoftwareAdvice"
                                @click="clearAndSyncReviews('SoftwareAdvice')">
                    <i class="fas fa-sync" v-if="!syncInProgressSoftwareAdvice"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-g2-crowd': form.g2_crowd}"
                        @click="reviewSite('g2_crowd')">
                    G2 Crowd
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.g2crowd.com/swell-reviews"
                    v-model="form.g2_crowd_url"
                    :form="form"
                    field="g2_crowd_url"
                    :readonly="!form.g2_crowd"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.g2_crowd">
                <a href="https://www.g2crowd.com" data-toggle="tooltip" target="_blank"
                    title="Find business software">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressG2"
                                @click="clearAndSyncReviews('G2')">
                    <i class="fas fa-sync" v-if="!syncInProgressG2"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-golf-now': form.golf_now}"
                        @click="reviewSite('golf_now')">
                    Golf Now
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.golfnow.com/swell-reviews"
                    v-model="form.golf_now_url"
                    :form="form"
                    field="golf_now_url"
                    :readonly="!form.golf_now"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.golf_now">
                <a href="https://www.golfnow.com" data-toggle="tooltip" target="_blank"
                    title="Find amazing deals on tee times">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressGolfNow"
                                @click="clearAndSyncReviews('GolfNow')">
                    <i class="fas fa-sync" v-if="!syncInProgressGolfNow"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-vitals': form.vitals}" @click="reviewSite('vitals')">
                    Vitals
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.vitals.com/profession/swell-reviews/reviews"
                    v-model="form.vitals_url"
                    :form="form"
                    field="vitals_url"
                    :readonly="!form.vitals"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.vitals">
                <a href="https://www.vitals.com" data-toggle="tooltip" target="_blank"
                    title="Find your perfil">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressVitals"
                                @click="clearAndSyncReviews('Vitals')">
                    <i class="fas fa-sync" v-if="!syncInProgressVitals"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <button class="btn w-100" :class="{'btn-healthgrades' : form.healthgrades}"
                    @click="reviewSite('healthgrades')">
                    Healthgrades
                </button>
            </div>
            <div class="col-8">
                <input-text
                    placeholder="https://www.healthgrades.com/physician/dr-swell-xn27p"
                    v-model="form.healthgrades_url"
                    :form="form"
                    field="healthgrades_url"
                    :readonly="!form.healthgrades"
                />
            </div>
            <div class="col-1 p-0" v-if="!form.healthgrades">
                <a href="https://www.healthgrades.com/" data-toggle="tooltip" target="_blank"
                    title="Find the right doctor. Get the best care">
                    <i class="fa fa-question"></i>
                </a>
            </div>
            <div class="col-1 p-0" v-else>
                <button-loading class="btn btn-sm btn-info"
                                type="button"
                                :loading="syncInProgressHealthgrades"
                                @click="clearAndSyncReviews('Healthgrades')">
                    <i class="fas fa-sync" v-if="!syncInProgressHealthgrades"></i>
                    <i v-else>syncing</i>
                </button-loading>
            </div>
        </div>
        <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
            <button class="btn btn-default" type="button" data-dismiss="modal">
                Close
            </button>
            <button-loading type="button" class="btn btn-primary ml-2"
                :loading="form.submitting"
                @click="save">
                Save
            </button-loading>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['location'],

        data() {
            return {
                form: new Form(),
                syncInProgressYelp: false,
                syncInProgressGoogle: false,
                syncInProgressTripAdvisor: false,
                syncInProgressCapterra: false,
                syncInProgressSoftwareAdvice: false,
                syncInProgressG2: false,
                syncInProgressGolfNow: false,
                syncInProgressVitals: false,
                syncInProgressHealthgrades: false,
                syncError: false,
                syncErrorMessage: '',
            }
        },

        watch: {
            location: {
                immediate: true,
                handler() {
                    if (this.location) {
                        this.syncInProgressYelp = this.location.syncing_yelp;
                        this.syncInProgressGoogle= this.location.syncing_google;
                        this.syncInProgressTripAdvisor= this.location.syncing_trip_advisor;
                        this.syncInProgressCapterra= this.location.syncing_capterra;
                        this.syncInProgressSoftwareAdvice= this.location.syncing_software_advice;
                        this.syncInProgressG2= this.location.syncing_g2_crowd;
                        this.syncInProgressGolfNow= this.location.syncing_golf_now;
                        this.syncInProgressVitals= this.location.syncing_vitals;
                        this.syncInProgressHealthgrades= this.location.syncing_healthgrades;
                        this.form = new Form({
                            location_id        : this.location.id,
                            yelp               : !!this.location.yelp_url,
                            yelp_url           : this.location.yelp_url,
                            google             : !!this.location.google_url,
                            google_url         : this.location.google_url,
                            trip_advisor       : !!this.location.trip_advisor_url,
                            trip_advisor_url   : this.location.trip_advisor_url,
                            capterra           : !!this.location.capterra_url,
                            capterra_url       : this.location.capterra_url,
                            software_advice    : !!this.location.software_advice_url,
                            software_advice_url: this.location.software_advice_url,
                            g2_crowd           : !!this.location.g2_crowd_url,
                            g2_crowd_url       : this.location.g2_crowd_url,
                            golf_now           : !!this.location.golf_now_url,
                            golf_now_url       : this.location.golf_now_url,
                            vitals             : !!this.location.vitals_url,
                            vitals_url         : this.location.vitals_url,
                            healthgrades       : !!this.location.healthgrades_url,
                            healthgrades_url   : this.location.healthgrades_url,
                        });

                        return;
                    }

                    this.form = new Form();
                }
            }
        },

        methods: {
            reviewSite(site) {
                this.form[site] = !this.form[site];
                if (!this.form[site]) {
                    this.form[`${site}_url`] = null;
                }
            },

            save() {
                return this.form.put(this.$laroute.route('manage-reviews.update', {location: this.form.location_id}))
                    .then(({data}) => {
                        this.syncError = false;
                        this.$emit('save-location', data.id);
                        swal.fire({
                            title: 'Location Saved!',
                            type: 'success',
                        })
                    })
                    .catch(error => console.error(error));
            },

            async clearAndSyncReviews(type = false) {
                const result = await this.$confirmDialog({
                    title: 'Clear Reviews for ' + type + ' and Re-sync?',
                    text: 'This may take several minutes to Re-sync after reviews have been cleared.',
                    confirmButtonText: 'Clear and Re-Sync Reviews',
                    closeOnConfirm: true
                });
                if (!result) return;
                this.$http.post(this.$laroute.route('api.locations.reviews.clean-and-token', {location: this.location.id}),
                                {review_type: type})
                    .then(({data}) => {
                        this.reviewSyncStatus(type, 'true');
                    }).catch( ({error}) => {
                        this.syncError = true;
                        this.syncErrorMessage = "Unable to clear and sync for " + type +  " at this time.";
                    });
            },

            reviewSyncStatus(type, active){
                eval('this.syncInProgress' + type + ' = ' + active + ';');
            }
        }
    }
</script>
